import React from "react";
import { convertDate, convertOnlyTime } from "../../../utils/convertDate";
import { fileUrl } from "../../../services/config";
import { PiFilePdf } from "react-icons/pi";

function TicketMessage({ data }) {
  const renderFile = (fileName) => {
    const fileExtension = fileName
      .slice(fileName.lastIndexOf(".") + 1)
      .toLowerCase();

    if (fileExtension === "pdf") {
      return (
        <div>
          <a href={`${fileUrl}files/${fileName}`} target="_blanck">
            <button
              type="button"
              className="inline-flex items-center text-red-700 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-3 py-1.5 text-center me-2 mt-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
            >
              <span>مشاهده فایل</span>
              <PiFilePdf className="mr-2 text-red-400" size={28} />
            </button>
          </a>
        </div>
      );
    } else if (
      fileExtension === "jpg" ||
      fileExtension === "jpeg" ||
      fileExtension === "png"
    ) {
      return (
        <div className="relative w-full">
          <img
            src={`${fileUrl}files/${fileName}`}
            alt="JPG Preview"
            className="w-full rounded-md"
          />
        </div>
      );
    } else {
      return <p>نوع فایل نامشخص : {fileName}</p>;
    }
  };

  return (
    <>
      {data?.user?.role !== "customer" ? (
        <div class="mx-4 bg-blue-50 dark:bg-neutral-500 p-4 rounded-md relative">
          <span class="absolute top-3 -right-4 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[20px] border-b-blue-50 dark:border-b-neutral-500 rotate-90"></span>
          <span class="block text-sm text-gray-500 dark:text-gray-100 mb-1">
            در تاریخ {convertDate(data?.createdAt, false)} در ساعت{" "}
            {convertOnlyTime(data?.createdAt)}
          </span>
          <p class="text-gray-700 dark:text-white text-justify text-sm leading-6">
            {data?.message}
          </p>
          {data?.files?.length ? (
            <div className="flex flex-wrap gap-4">
              {data?.files?.map((item) => {
                return <div className="max-w-sm">{renderFile(item)}</div>;
              })}
            </div>
          ) : null}
        </div>
      ) : (
        <div class="mx-4 bg-purple-50 dark:bg-neutral-700 p-4 rounded-md relative">
          <span class="absolute top-3 -left-4 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[20px] border-b-purple-50 dark:border-b-neutral-700  -rotate-90"></span>
          <span class="block text-sm text-gray-500 dark:text-gray-100 mb-1">
            در تاریخ {convertDate(data?.createdAt, false)} در ساعت{" "}
            {convertOnlyTime(data?.createdAt)}
          </span>
          <p class="text-gray-700 dark:text-white text-justify text-sm leading-6">
            {data?.message}
          </p>
          {data?.files?.length ? (
            <div className="flex flex-wrap gap-4">
              {data?.files?.map((item) => {
                return <div className="max-w-sm">{renderFile(item)}</div>;
              })}
            </div>
          ) : null}
        </div>
      )}
    </>
  );
}

export default TicketMessage;
